<div class="sc-notification-content">
  <div fxLayout="row">
    <div fxFlex="75" class="sc-notification-heading sc-color-gray">
      <span class="sc-heading"
        >Notifications
        <span *ngIf="storesService.notificationCount">{{
          "(" + storesService.notificationCount + ")"
        }}</span></span
      >
    </div>
    <div
      fxHide.lt-sm
      fxFlex="59"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="end"
      class="sc-notification-text sc-color-dark sc-clear-all"
      *ngIf="
        storesService.notifications && storesService.notifications.length > 0
      "
    >
      <div
        fxLayout="column"
        (click)="clearNotifications('clearall')"
        class="ws-cursor-pointer ws-no-wrap"
      >
        Clear All
      </div>
      <div
        *ngIf="storesService.notificationCount > 0"
        fxLayout="column"
        class="sc-vertical-line"
      ></div>
      <div
        fxLayout="column"
        (click)="clearNotifications('markallread')"
        class="ws-cursor-pointer ws-no-wrap"
        *ngIf="storesService.notificationCount > 0"
      >
        Mark all as read
      </div>
    </div>
    <div
      fxHide.gt-xs
      fxFlex="18"
      fxLayout="column"
      fxLayoutAlign="space-between end"
      *ngIf="
        storesService &&
        storesService.notifications &&
        storesService.notifications.length > 0
      "
    >
      <div fxLayout="row" [matMenuTriggerFor]="clearMenu">
        <i class="fa fa-ellipsis-v ws-ellipsis"></i>
      </div>
      <mat-menu #clearMenu="matMenu">
        <button mat-menu-item (click)="clearNotifications('clearall')">
          Clear All
        </button>
        <button
          mat-menu-item
          (click)="clearNotifications('markallread')"
          *ngIf="storesService.notificationCount > 0"
        >
          Mark all as read
        </button>
      </mat-menu>
    </div>
  </div>
  <div
    class="sc-notification-scroll sc-notifications-height"
    (scroll)="getNotificationsList($event)"
    *ngIf="storesService.notifications && storesService.notifications.length"
  >
    <div
      *ngFor="let notification of storesService.notifications; let i = index"
      class="sc-notification-text sc-each-date"
      [ngClass]="{ 'sc-margin-top-zero': i === 0 }"
    >
      <div fxLayout="row">
        <span class="sc-notification-date">{{
          getDate(notification._id) | date: locationService.format.longYearDate
        }}</span>
      </div>
      <div
        *ngFor="let unit of notification.notifications"
        (click)="openOrder(unit)"
        class="ws-cursor-pointer"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="space-around center"
          class="sc-each-notification"
        >
          <div fxFlex="10">
            <img [src]="getIcon(unit)" />
          </div>
          <div fxLayout="column" fxFlex="80">
            <div fxLayout="row" fxLayoutGap="10px">
              <span class="sc-color-dark">{{ getTitle(unit) }}</span>
              <span class="sc-notification-date">{{ getTime(unit) }}</span>
            </div>
            <div fxLayout="row">
              <span class="sc-color-gray">{{ getUser(unit) }}</span>
            </div>
          </div>
          <div class="ws-dot" fxFlex="10">
            <div *ngIf="!unit.viewed" class="sc-icon-image-dot"></div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isNotificationsFetch" class="ws-bold">Loading ...</div>
  </div>
  <div
    *ngIf="!storesService.notifications?.length"
    class="sc-no-notifications sc-notification-heading sc-color-dark"
  >
    No Notifications to display
  </div>
</div>
